export const COMPANY_NAME = process.env.REACT_APP_BRANDING === 'IPLS' ? 'IPLS' : 'Nucleo'; // default to Nucleo
export const BRANDING = process.env.REACT_APP_BRANDING === 'IPLS' ? 'IPLS' : 'NUCLEO'; // default to Nucleo
export const EMAIL_SUPPORT = process.env.REACT_APP_BRANDING === 'IPLS' ? 'info@ipls.online' : 'support@go-nucleo.com'; // default to Nucleo
